// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__lcIc-","bigColWidth":"Table_bigColWidth__1jKEt","biggerColWidth":"Table_biggerColWidth__1xRC0","row":"Table_row__3ieg6","col":"Table_col__Vz8a8"};